<template lang="pug">
el-collapse#empresa-bloco-inserir-contrato-originacao-manualmente
    el-collapse-item(name='cadastroManual')
        h2.cadastro-contrato-originacao__subtitulo(slot='title') {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.titulo') }}

        el-card(:body-style='{ padding: "20px" }', shadow='never')
            el-form(
                label-position='top',
                :model='formCadastroManual',
                :rules='formCadastroManualRegras',
                ref='formCadastroManualRef'
            )
                .row-4
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.numeroContrato")',
                        prop='numeroContrato'
                    )
                        el-input#numeroContrato(
                            v-model.number='formCadastroManual.numeroContrato',
                            :placeholder='$t("mensagens.comuns.placeholder")',
                            maxlength='10'
                        )
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.corredor")',
                        prop='corredor'
                    )
                        el-select#corredor(
                            v-model='formCadastroManual.corredor',
                            v-loading='carregandoFornecedores',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='fornecedor in fornecedores',
                                :key='fornecedor.id',
                                :label='fornecedor.nome',
                                :value='fornecedor.id'
                            )
                    el-form-item(prop='sucursal')
                        template(slot='label')
                            span.sucursal-label
                                | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.sucursal') }}
                                el-tooltip(
                                    effect='dark',
                                    placement='top',
                                    :content='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.sucursalTooltip")'
                                )
                                    i.mdi.mdi-information-outline.sucursal-label__icon
                        el-select#sucursal(
                            v-model='formCadastroManual.sucursal',
                            v-loading='carregandoSucursais',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='sucursal in sucursais',
                                :key='sucursal.id',
                                :label='sucursal.label',
                                :value='sucursal.id'
                            )
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.vendedor")',
                        prop='vendedor'
                    )
                        el-input#vendedor(
                            v-model='formCadastroManual.vendedor',
                            :placeholder='$t("mensagens.comuns.placeholder")'
                        )
                .row-4
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.produto")',
                        prop='cultura'
                    )
                        el-select#cultura(
                            v-model='formCadastroManual.cultura',
                            v-loading='carregandoCulturas',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='cultura in culturas',
                                :key='cultura.id',
                                :label='cultura.nome',
                                :value='cultura.id'
                            )
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.anoAfip")',
                        prop='anoAfip'
                    )
                        el-select#anoAfip(
                            v-model='formCadastroManual.anoAfip',
                            v-loading='carregandoSafras',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='safra in safras',
                                :key='safra.id',
                                :label='safra.ano',
                                :value='safra.id'
                            )
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.dataContrato")',
                        prop='dataContrato'
                    )
                        el-date-picker#dataContrato(
                            v-model='formCadastroManual.dataContrato',
                            type='date',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            format='dd/MM/yyyy'
                        )
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.dataEntrega")',
                        prop='dataEntrega'
                    )
                        el-date-picker#dataEntrega(
                            v-model='formCadastroManual.dataEntrega',
                            type='date',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            format='dd/MM/yyyy'
                        )
                .row-3
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.cuitVendedor")',
                        prop='cuitVendedor'
                    )
                        el-input#cuitVendedor(
                            v-model='formCadastroManual.cuitVendedor',
                            v-mask='["##-########-#"]',
                            :placeholder='$t("mensagens.comuns.placeholder")'
                        )
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.condicaoClienteLabel")',
                        prop='condicaoCliente'
                    )
                        el-select#condicaoCliente(
                            v-model='formCadastroManual.condicaoCliente',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='condicao in condicoes',
                                :key='condicao.id',
                                :label='condicao.label',
                                :value='condicao.value'
                            )
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.provincia")',
                        prop='provincia'
                    )
                        el-select#provincia(
                            v-model='formCadastroManual.provincia',
                            v-loading='carregandoNivelUm',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='provincia in provincias',
                                :key='provincia.id',
                                :label='provincia.label',
                                :value='provincia.id'
                            )
                .row-4
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.departamento")',
                        prop='departamento'
                    )
                        el-select#departamento(
                            v-model='formCadastroManual.departamento',
                            v-loading='carregandoNivelDois',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='departamento in departamentos',
                                :key='departamento.id',
                                :label='departamento.label',
                                :value='departamento.id'
                            )
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.origem")',
                        prop='localidade'
                    )
                        el-select#localidade(
                            v-model='formCadastroManual.localidade',
                            v-loading='carregandoNivelTres',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='localidade in localidades',
                                :key='localidade.id',
                                :label='localidade.label',
                                :value='localidade.id'
                            )
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.estrutura")',
                        prop='estrutura'
                    )
                        el-input#estrutura(
                            v-model='formCadastroManual.estrutura',
                            :placeholder='$t("mensagens.comuns.placeholder")'
                        )
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.volumeContratado")',
                        prop='volumeContratado'
                    )
                        el-input#volumeContratado(
                            v-model='formCadastroManual.volumeContratado',
                            :placeholder='$t("mensagens.comuns.placeholder")'
                        )
                .row-add
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.idPlantaEntregaBunge")',
                        prop='idPlantaEntregaBunge'
                    )
                        el-select#idPlantaEntregaBunge(
                            v-model='formCadastroManual.idPlantaEntregaBunge',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='destino in destinos',
                                v-loading='carregandoPlantas',
                                :key='destino.id',
                                :label='destino.nome',
                                :value='destino.id'
                            )
                    el-form-item(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.condicaoFrete")',
                        prop='condicaoFrete'
                    )
                        el-select#condicaoFrete(
                            v-model='formCadastroManual.condicaoFrete',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='frete in fretes',
                                :key='frete.id',
                                :id='frete.id',
                                :label='frete.label',
                                :value='frete.value'
                            )
                    el-button#adicionar.adicionarTerritorio(
                        type='primary',
                        :disabled='adicionandoContrato || !volumeContratadoValido',
                        @click='adicionarAR'
                    )
                        i.el-icon(
                            :class='adicionandoContrato ? "el-icon-loading" : "el-icon-plus"'
                        )
                        | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.adicionarLista') }}
</template>

<script>
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
import { validateCuit } from '@/utils/validations/cuit';
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import LocalidadeService from '@/services/LocalidadeService';
import SucursaleService from '@/services/SucursaleService';

export default {
    name: 'EmpresaBlocoInserirContratoOriginacaoManualmente',

    data() {
        const validarNumeroContrato = (rule, value, callback) => {
            if (value === '') {
                callback(
                    new Error(this.$t('mensagens.comuns.campoObrigatorio'))
                );
                return;
            }

            if (value.toString().length !== 10) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroContrato'
                        )
                    )
                );
                return;
            }

            const apenasNumeros = /^\d*$/;
            if (!apenasNumeros.test(value)) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoCaracterNumeroContrato'
                        )
                    )
                );
                return;
            }

            callback();
        };

        const validarVolumeContratado = (rule, value, callback) => {
            // Verifica se o campo está vazio
            if (value === '') {
                callback(
                    new Error(this.$t('mensagens.comuns.campoObrigatorio'))
                );
                return;
            }

            // Não permite valores com ponto (.)
            if (value.toString().includes('.')) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorComPontos'
                        )
                    )
                );
                return;
            }

            // Não permite mais de uma vírgula e vírgulas no início ou fim do valor
            const regexMaisDeUmaVirgula = /.*,.*,.*/;
            if (
                regexMaisDeUmaVirgula.test(value) ||
                value.startsWith(',') ||
                value.endsWith(',')
            ) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroMalFormatado'
                        )
                    )
                );
                return;
            }

            // Permite apenas números e uma única vírgula para decimais
            const regexNumeroVirgula = /^\d+(,\d{1,3})?$/;
            if (!regexNumeroVirgula.test(value)) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorNaoAceito'
                        )
                    )
                );
                return;
            }

            // Converte a string para número
            const valorNumerico = parseFloat(value.replace(',', '.'));
            if (valorNumerico <= 0) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorZerado'
                        )
                    )
                );
                return;
            }

            // Se todas as validações passarem
            callback();
        };

        const validationDocument = (_, value, callback) => {
            if (!validateCuit(value)) {
                callback(this.$t('mensagens.pessoas.cuitErro'));
            } else {
                callback();
            }
        };

        return {
            formCadastroManual: {
                numeroContrato: '',
                corredor: '',
                sucursal: '',
                vendedor: '',
                cultura: '',
                anoAfip: '',
                dataContrato: '',
                dataEntrega: '',
                cuitVendedor: '',
                condicaoCliente: '',
                provincia: '',
                departamento: '',
                localidade: '',
                estrutura: '',
                volumeContratado: '',
                idPlantaEntregaBunge: '',
                condicaoFrete: ''
            },
            formCadastroManualRegras: {
                numeroContrato: [
                    {
                        required: true,
                        validator: validarNumeroContrato,
                        trigger: 'blur'
                    }
                ],
                corredor: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                sucursal: [
                    {
                        required: false,
                        trigger: 'change'
                    }
                ],
                vendedor: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                cultura: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                anoAfip: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                dataContrato: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                dataEntrega: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                cuitVendedor: [
                    {
                        required: true,
                        validator: validationDocument,
                        trigger: 'blur'
                    }
                ],
                condicaoCliente: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                provincia: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                departamento: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                localidade: [
                    {
                        required: false,
                        trigger: 'change'
                    }
                ],
                estrutura: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                volumeContratado: [
                    {
                        required: true,
                        validator: validarVolumeContratado,
                        trigger: 'blur'
                    }
                ],
                idPlantaEntregaBunge: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                condicaoFrete: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ]
            },
            fornecedores: [],
            sucursais: [],
            provincias: [],
            departamentos: [],
            localidades: [],
            culturas: [],
            safras: [],
            condicoes: [
                {
                    id: 1,
                    value: 'acopiador',
                    label: this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.coletor'
                    )
                },
                {
                    id: 2,
                    value: 'cosignatario',
                    label: this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.destinatario'
                    )
                },
                {
                    id: 3,
                    value: 'produtor',
                    label: this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.produtor'
                    )
                }
            ],
            fretes: [
                { id: 1, value: 'CIF', label: 'CIF' },
                { id: 2, value: 'FOB', label: 'FOB' }
            ],
            destinos: [],
            carregandoNivelUm: false,
            carregandoNivelDois: false,
            carregandoNivelTres: false,
            carregandoSafras: false,
            carregandoCulturas: false,
            carregandoFornecedores: false,
            carregandoSucursais: false,
            carregandoPlantas: false,
            adicionandoContrato: false,
            ambientes: AmbientesEmpresas,
            pickerOptionsDataContrato: {
                disabledDate: date => date > new Date()
            }
        };
    },

    mounted() {
        this.listarLocalidadeNivelUm();
        this.buscarFornecedores();
        this.plantasEntregaBunge();
        this.buscarCulturas();
        this.buscarSafras();
    },

    computed: {
        volumeContratadoValido() {
            const value = this.formCadastroManual.volumeContratado;
            if (!value || value.toString().includes('.')) {
                return false;
            }
            const regexMaisDeUmaVirgula = /.*,.*,.*/;
            if (
                regexMaisDeUmaVirgula.test(value) ||
                value.startsWith(',') ||
                value.endsWith(',')
            ) {
                return false;
            }
            if (!/^\d+(,\d{1,3})?$/.test(value)) {
                return false;
            }
            return parseFloat(value.replace(',', '.')) > 0;
        }
    },

    watch: {
        'formCadastroManual.volumeContratado'(newVal) {
            if (newVal && newVal.toString().includes('.')) {
                this.formCadastroManual.volumeContratado = newVal
                    .toString()
                    .replace('.', ',');
            }
        },
        'formCadastroManual.corredor'(newVal) {
            if (newVal) {
                this.listarSucursais(newVal);
                this.resetFieldIfNotEmpty('sucursal');
            }
        },
        'formCadastroManual.provincia'(newVal) {
            if (newVal) {
                this.listarLocalidadeNivelDois(newVal);
                this.resetFieldIfNotEmpty('departamento');
                this.resetFieldIfNotEmpty('localidade');
            }
        },
        'formCadastroManual.departamento'(newVal) {
            if (newVal) {
                this.listarLocalidadeNivelQuatro(newVal);
                this.resetFieldIfNotEmpty('localidade');
            }
        }
    },
    methods: {
        adicionarAR() {
            this.$refs.formCadastroManualRef.validate(valid => {
                if (!valid) {
                    this.$notify.warning(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoTodosCampos'
                        )
                    );
                    return false;
                }

                this.adicionandoContrato = true;

                const form = this.formCadastroManual;

                const payload = {
                    numeroContrato: form.numeroContrato,
                    contratoOriginacaoFornecedorParceiro: { id: form.corredor },
                    sucursal: form.sucursal,
                    cuitVendedor: form.cuitVendedor,
                    nomeVendedor: form.vendedor,
                    idMaterial: form.cultura,
                    idSafra: form.anoAfip,
                    dataContrato: form.dataContrato.getTime(),
                    dataPrevistaEntrega: form.dataEntrega.getTime(),
                    idDepartamento: form.departamento,
                    idLocalidade: form.localidade,
                    volumeContratado: parseFloat(
                        form.volumeContratado.replace(',', '.')
                    ),
                    idPlantaEntregaBunge: form.idPlantaEntregaBunge,
                    condicaoCliente: form.condicaoCliente,
                    estructuraComercial: form.estrutura,
                    condicaoFrete: form.condicaoFrete
                };

                ContratoOriginacaoServiceEmpresa.cadastrarManualmenteAR(payload)
                    .then(() => {
                        this.$notify.success(
                            `${this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contrato'
                            )} ${form.numeroContrato} ${this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contratoInserido'
                            )}`
                        );

                        this.$emit('contrato-inserido');
                        this.limpar();
                    })
                    .catch(erro => {
                        this.$notify.error({
                            message:
                                erro.response?.data?.message ||
                                'Erro ao cadastrar contrato.'
                        });
                    })
                    .finally(() => {
                        this.adicionandoContrato = false;
                    });
            });
        },

        async buscarFornecedores() {
            try {
                this.carregandoFornecedores = true;
                const { data } =
                    await ContratoOriginacaoService.buscarBpClientes();
                this.fornecedores = data;

                this.carregandoFornecedores = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarFornecedor'
                    )
                );
            }
        },

        async buscarCulturas() {
            try {
                this.carregandoCulturas = true;

                const { data } =
                    await ContratoOriginacaoService.buscarCulturas();
                this.culturas = data;

                this.carregandoCulturas = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarCultura'
                    )
                );
            }
        },

        async buscarSafras() {
            try {
                this.carregandoSafras = true;
                const { data } = await ContratoOriginacaoService.buscarSafras();

                this.safras = data;
                this.carregandoSafras = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarSafra'
                    )
                );
            }
        },

        async plantasEntregaBunge() {
            try {
                this.carregandoPlantas = true;
                const response =
                    await ContratoOriginacaoServiceEmpresa.plantasEntregaBunge();
                const { data } = response;

                this.destinos = data;
                this.carregandoPlantas = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarEstados'
                    )
                );
            }
        },

        async listarLocalidadeNivelUm() {
            try {
                this.carregandoNivelUm = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelUm();

                const dataFormat = data
                    .map(item => {
                        return { label: item.nome, id: item.id };
                    })
                    .sort((a, b) => this.orderName(a, b));

                this.provincias = dataFormat;
                this.carregandoNivelUm = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelUm'
                    )
                });
            }
        },

        async listarSucursais(id) {
            try {
                this.carregandoSucursais = true;
                const { data } =
                    await SucursaleService.buscarSucursaisPorRevenda(id);
                const dataFormat = data.sucursais
                    .map(item => {
                        return { label: item.nome, id: item.id };
                    })
                    .sort((a, b) => this.orderName(a, b));
                this.sucursais = dataFormat;
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.sistema.erroInformacoes')
                });
            } finally {
                this.carregandoSucursais = false;
            }
        },

        async listarLocalidadeNivelDois(id) {
            try {
                this.carregandoNivelDois = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelDois(id);
                const dataFormat = data
                    .map(item => {
                        return { label: item.nome, id: item.id };
                    })
                    .sort((a, b) => this.orderName(a, b));
                this.departamentos = dataFormat;
                this.carregandoNivelDois = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
            }
        },

        async listarLocalidadeNivelTres(id) {
            try {
                this.carregandoNivelTres = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelTres(id);
                const dataFormat = data
                    .map(item => {
                        return { label: item.nome, id: item.id };
                    })
                    .sort((a, b) => this.orderName(a, b));

                this.localidades = dataFormat;
                this.carregandoNivelTres = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
            }
        },

        async listarLocalidadeNivelQuatro(id) {
            try {
                this.carregandoNivelTres = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelQuatro(id);
                this.localidades = [];
                if (data) {
                    const dataFormat = data
                        .map(item => {
                            return { label: item.nome, id: item.id };
                        })
                        .sort((a, b) => this.orderName(a, b));

                    this.localidades = dataFormat;
                }

                this.carregandoNivelTres = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
            }
        },

        formatarData(data) {
            const adjustedDate = new Date(data.getTime() - 3 * 60 * 60 * 1000);
            const formattedDate = adjustedDate.toISOString().slice(0, -5);
            return formattedDate;
        },

        resetFieldIfNotEmpty(field) {
            if (this.formCadastroManual[field]) {
                this.formCadastroManual[field] = '';
            }
        },

        orderName(a, b) {
            const nameA = a.label.toUpperCase();
            const nameB = b.label.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        },

        limpar() {
            this.$refs['formCadastroManualRef'].resetFields();
        }
    }
};
</script>

<style lang="scss">
#empresa-bloco-inserir-contrato-originacao-manualmente {
    .el-icon-arrow-right:before {
        content: '\E7A0';
        font-size: 24px;
        padding: 10px;
        color: var(--primary);
    }
    h2.cadastro-contrato-originacao__subtitulo {
        font-size: 16px;
        font-weight: bold;

        margin-bottom: 0px;
        margin-left: 20px;
    }

    .el-card {
        border: none;
    }

    .el-collapse-item {
        border-radius: 10px;
        overflow: hidden;
    }

    .el-collapse-item__content {
        padding: 0px;
    }

    .el-form-item {
        width: 100%;
        padding: 0 4px;
    }

    .sucursal-label {
        display: inline-flex;
        align-items: center;
        gap: 4px;

        &__icon {
            color: var(--primary);
            cursor: help;
            font-size: 16px;
            line-height: 1;
        }
    }

    .el-select,
    .el-input,
    .el-date-picker,
    .el-button {
        width: 100%;
    }

    .row-3 {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 14px;
    }

    .row-4 {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 14px;
    }

    .row-add {
        display: grid;
        grid-template-columns: 1.5fr 1.5fr 0.75fr;
        gap: 14px;
    }

    .adicionarTerritorio {
        height: fit-content;
        margin: auto 0 8px 0;
        span i {
            color: white !important;
            margin-right: 8px;
        }
        &:disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }
    }

    .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label::before,
    .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:before {
        content: none !important;
        margin-right: 0px !important;
    }

    .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after,
    .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:after {
        content: '*';
        color: #f56c6c;
        margin-left: 4px;
    }
}
</style>
